<template>
  <div class="file-uploader" @click="handleUpload">
    <input
        type="file"
        :name="inputName"
        :accept="acceptTypes.join(',')"
        ref="input"
        @change="validateFile"
    />
    <div
        class="file-uploader__label"
        :style="{ borderStyle: hasFile ? 'solid' : 'dashed' }"
    >
      <p class="file-uploader__text" v-if="this.fileName">
        {{ fileName }}
      </p>
      <p class="file-uploader__text _default" v-else>
        <slot>Choose a file to upload.</slot>
      </p>
      <div class="file-uploader__right">
        <p v-if="fileSize" class="file-uploader__size">
          {{ fileSize }}
        </p>
        <svg
            class="file-uploader__icon"
            v-if="hasFile"
            @click.stop="removeFile"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
        >
          <g
              id="Group_520"
              data-name="Group 520"
              transform="translate(-1425 -2234.5)"
          >
            <g
                id="Rectangle_529"
                data-name="Rectangle 529"
                transform="translate(1425 2234.5)"
                fill="#006abc"
                stroke="#006abc"
                stroke-width="1"
            >
              <rect
                  width="20"
                  height="20"
                  rx="10"
                  stroke="none"
              />
              <rect
                  x="0.5"
                  y="0.5"
                  width="19"
                  height="19"
                  rx="9.5"
                  fill="none"
              />
            </g>
            <g
                id="Group_421"
                data-name="Group 421"
                transform="translate(2209.049 -72.457) rotate(45)"
            >
              <path
                  id="Path_1170"
                  data-name="Path 1170"
                  d="M18355.564,14568.75h-10.994a.75.75,0,0,1,0-1.5h10.994a.75.75,0,0,1,0,1.5Z"
                  transform="translate(-17259.066 -12382.329)"
                  fill="#fff"
              />
              <path
                  id="Path_1171"
                  data-name="Path 1171"
                  d="M18355.564,14568.75h-10.994a.75.75,0,0,1,0-1.5h10.994a.75.75,0,0,1,0,1.5Z"
                  transform="translate(15659 -16164.397) rotate(90)"
                  fill="#fff"
              />
            </g>
          </g>
        </svg>
        <svg
            class="file-uploader__icon"
            v-else
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20"
            height="20.654"
            viewBox="0 0 20 20.654"
        >
          <defs>
            <linearGradient
                id="linear-gradient"
                x1="0.5"
                y1="1"
                x2="0.5"
                y2="-0.367"
                gradientUnits="objectBoundingBox"
            >
              <stop offset="0" stop-color="#006abc"/>
              <stop offset="1" stop-color="#00e2ff"/>
            </linearGradient>
            <linearGradient
                id="linear-gradient-2"
                y1="-0.194"
                y2="1"
                xlink:href="#linear-gradient"
            />
          </defs>
          <g
              id="Group_521"
              data-name="Group 521"
              transform="translate(-1488 -1982)"
          >
            <path
                id="download"
                d="M20,13.7V17.78a.905.905,0,0,1-.937.874H.938A.905.905,0,0,1,0,17.78V13.7a.905.905,0,0,1,.938-.874h5.73L8.582,14.61a2.105,2.105,0,0,0,2.836,0l1.914-1.785h5.73A.905.905,0,0,1,20,13.7Zm-4.844,3.206a.783.783,0,1,0-.781.729A.759.759,0,0,0,15.156,16.905Zm2.5,0a.783.783,0,1,0-.781.729A.759.759,0,0,0,17.656,16.905Z"
                transform="translate(1488 1984)"
                fill="url(#linear-gradient)"
            />
            <path
                id="download-2"
                data-name="download"
                d="M8.438,0h3.125A.905.905,0,0,1,12.5.874V7h3.426a.722.722,0,0,1,.551,1.242l-5.941,5.545a.8.8,0,0,1-1.066,0L3.52,8.238A.722.722,0,0,1,4.07,7H7.5V.874A.905.905,0,0,1,8.438,0Z"
                transform="translate(1507.707 1995.988) rotate(180)"
                fill="url(#linear-gradient-2)"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FileUploader",
  props: ["inputName"],
  data() {
    return {
      fileName: "",
      fileValue: "",
      fileExt: "",
      fileSize: "",
      hasFile: false,
      acceptTypes: [
        "image/jpeg",
        "image/png",
        "application/vnd.rar",
        "application/x-rar-compressed",
        "application/octet-stream",
        "application/zip",
        "application/x-zip-compressed"
      ]
    };
  },
  methods: {
    handleUpload() {
      this.$refs.input.click();
    },
    formatFileSize(size) {
      if (size >= 1024 * 1024) {
        return `${(size / 1024 / 1024).toFixed(2)} MB`;
      } else if (size >= 1024) {
        return `${(size / 1024).toFixed(2)} KB`;
      } else {
        return `${size} B`;
      }
    },

    validateFile(e) {
      const target = e.target;
      const file = target.files[0];
      if (file) {
        const size = file.size;
        const type = file.type;

        if (!this.acceptTypes.includes(type)) {
          target.value = "";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "PNG, JPG and Zip files only"
          });
        } else if (size > 5 * 1024 * 1024) {
          target.value = "";
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "File size less than 5MB"
          });
        } else {
          this.fileName = file.name;
          this.fileSize = this.formatFileSize(size);
          this.hasFile = true;
        }
      }
    },
    removeFile() {
      this.$refs.input.value = "";
      this.fileName = "";
      this.fileSize = "";
      this.hasFile = false;
    }
  },
  mounted() {
  }
};
</script>
<style lang="scss">
.file-uploader {
  display: block;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 15px;
  }

  input[type="file"] {
    display: none;
  }

  &__label {
    width: 100%;
    height: 45px;
    background-color: #ededed;
    border: 1px #006abc;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    padding-right: 20px;
    cursor: pointer;
  }

  &__right {
    display: flex;
    align-items: center;
  }

  &__text {
    font-size: 18px;
    color: #b1b1b1;
    line-height: 45px;
    flex: 1;
    height: 100%;
    vertical-align: middle;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &._default {
      font-weight: 700;
      color: #505050;
    }
  }

  &__size {
    font-size: 15px;
    color: #b1b1b1;
    margin-right: 12px;
  }

  &__icon {
    width: 20px;
    flex-shrink: 0;
  }
}
</style>
